import { useState } from "react";
import { Box, Button, TextField, Card, CardMedia } from "@mui/material";
import Detail from "../../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterCertificates } from "./UseFooterCertificates";
import { useNavigate, useLocation } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../../hooks/useBreakpoints";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function AddCertificate() {
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { SetFooterCertificates, validateCertificate } =
    UseFooterCertificates();
  const { isSmall } = useBreakpoints();
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );
  const [state, setState] = useState({
    script: undefined,
    title: undefined,
    footerID: homePageId ? homePageId.id : 1,
  });

  const [imgState, setImgState] = useState({
    imageFile: undefined,
    imageUrl: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      imageFile: file[0],
      imageUrl: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/footerManage",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت فوتر",
            url: "/footerManage",
          },
          {
            name: "افزودن گواهینامه",
            url: "/footerManage/addCertificate",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            label="عنوان"
            error={errorState.title}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 8"}>
          <TextField
            fullWidth
            value={state.script ? state.script : ""}
            label="اسکریپت"
            sx={{
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, script: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 4"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    // bgcolor: "#d3d3d3",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl
                        ? imgState.imageUrl
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 3"}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validateCertificate(state, setErrorState) == 200) {
                setProgress(true);
                SetFooterCertificates(state, imgState.imageFile, (calback) => {
                  navigate("/footerManage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
